var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgToStartContour = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13V9H13V10.5H10.5V13H9ZM9 19V15H10.5V17.5H13V19H9ZM17.5 13V10.5H15V9H19V13H17.5ZM15 19V17.5H17.5V15H19V19H15ZM17.775 7H15.7C15.2667 5.53333 14.4417 4.33333 13.225 3.4C12.0083 2.46667 10.6 2 9 2C7.05 2 5.39567 2.67933 4.037 4.038C2.67833 5.39667 1.99933 7.05067 2 9C2 10.2 2.271 11.3 2.813 12.3C3.355 13.3 4.084 14.1167 5 14.75V12H7V18H1V16H3.35C2.31667 15.1667 1.5 14.146 0.9 12.938C0.3 11.73 0 10.4173 0 9C0 7.75 0.237667 6.57933 0.713 5.488C1.18833 4.39667 1.82967 3.44667 2.637 2.638C3.44433 1.82933 4.39433 1.18767 5.487 0.713C6.57967 0.238333 7.75067 0.000666667 9 0C11.15 0 13.0377 0.662667 14.663 1.988C16.2883 3.31333 17.3257 4.984 17.775 7Z",
    fill: "#2C3038"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToStartContour);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/toStartContour.a97135d49d72d85feed9a6fc9612d375.svg";